import React from 'react';
import { CancellationModal } from './modals/CancellationModal';
import { CannotRescheduleGroupModal } from './modals/CannotRescheduleGroupModal';
import { ModalType } from '../../types';

export const config = {
  [ModalType.Cancellation]: (props: any) => <CancellationModal {...props} />,
  [ModalType.CannotRescheduleGroup]: (props: any) => (
    <CannotRescheduleGroupModal {...props} />
  ),
};
